import React, { useContext } from 'react';

const DomainContext = React.createContext();

const useDomainContext = () => {
  return useContext(DomainContext);
};

export { DomainContext, useDomainContext };
